export const craftMessages = {
  fr: {
    'Discover the standards behind every al-Malaki Rida, from its measurements to color-matched threadwork inside and out.':
      'Découvrez les exigences qui guident chaque Rida al-Malaki, des mesures aux fils assortis au tissu, à l’intérieur comme à l’extérieur.',
    'Our standards': 'Nos exigences',
    'The details we do not compromise on': 'Les détails sur lesquels nous ne transigeons pas',
    'Every Rida we deliver must meet these measurements and threadwork standards.':
      'Chaque Rida que nous livrons doit respecter ces mesures et les exigences relatives aux fils.',
    'Ghaghra length': 'Longueur du ghaghra',
    'Ghaghra gher': 'Gher du ghaghra',
    'Pardi length': 'Longueur du pardi',
    'Pardi gher': 'Gher du pardi',
    inches: 'pouces',
    Threadwork: 'Travail de fil',
    'Threadwork matches the fabric color, even on the inside.':
      'Les fils sont assortis à la couleur du tissu, même à l’intérieur.',
  },
  ar: {
    'Discover the standards behind every al-Malaki Rida, from its measurements to color-matched threadwork inside and out.':
      'اكتشفوا المعايير التي نلتزم بها في كل رداء من al-Malaki، من المقاسات إلى تطابق لون الخيوط مع القماش من الداخل والخارج.',
    'Our standards': 'معاييرنا',
    'The details we do not compromise on': 'تفاصيل لا نساوم عليها',
    'Every Rida we deliver must meet these measurements and threadwork standards.':
      'يجب أن يلتزم كل رداء نقدمه بهذه المقاسات ومعايير تطابق لون الخيوط مع القماش.',
    'Ghaghra length': 'طول الغاغرا',
    'Ghaghra gher': 'اتساع الغاغرا',
    'Pardi length': 'طول الباردي',
    'Pardi gher': 'اتساع الباردي',
    inches: 'بوصة',
    Threadwork: 'التطريز بالخيوط',
    'Threadwork matches the fabric color, even on the inside.':
      'يتطابق لون الخيوط مع لون القماش، حتى من الداخل.',
  },
} satisfies Record<'fr' | 'ar', Record<string, string>>;